import React from 'react';
import { Card, CardBody, Body, CardFooter, Badge } from 'legion-ui';
import { navigate } from 'gatsby';

const Overview = ({ data }) => {
  const handleClick = (link) => {
    navigate(link);
  };
  return (
    <React.Fragment>
      {data.map((value, index) => (
        <Card variant="bordered" key={index} onClick={() => handleClick(value.link)} isHoverable isPressable>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
            }}
          >
            <CardBody>
              <img src={value.image} alt="card variant" style={{ width: '100%' }} />
              <Body as="h3" size="lg_bold" color="tertiary800" mb={3} mt={3} style={{ fontFamily: 'unset' }}>
                {value.title}
              </Body>
              <Body size="sm_regular" color="tertiary500">
                {value.description}
              </Body>
            </CardBody>
            <CardFooter>
              <div>
                {value?.website && (
                  <Badge size="small" variant="info">
                    Website
                  </Badge>
                )}
                {value?.android && (
                  <Badge size="small" variant="success">
                    Android
                  </Badge>
                )}
                {value?.ios && (
                  <Badge size="small" variant="warning">
                    iOS
                  </Badge>
                )}
              </div>
            </CardFooter>
          </div>
        </Card>
      ))}
    </React.Fragment>
  );
};

export default Overview;
